import createReactComponent from '../createReactComponent';
export default createReactComponent('zodiac-aquarius', 'IconZodiacAquarius', [
  ['path', { d: 'M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3', key: 'svg-0' }],
  ['path', { d: 'M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3', key: 'svg-1' }],
]);
